import { useMemo } from 'react';
import { prop, isEmpty } from 'ramda';
import { useAppSelector } from 'js/store/hooks';

import { getGame } from './helpers';

export const useGameConfig = (code) => {
    const games = useAppSelector(prop('games'));

    return useMemo(() => {
        const game = getGame(code)(games);
        const { gameCode, seoFriendlyGameName } = game;

        if (isEmpty(game)) {
            return game;
        }

        return {
            ...game,
            gameUrlFragment: seoFriendlyGameName || gameCode
        };
    }, [games, code]);
};
